import { Button, Flex, Text, useDisclosure } from '@chakra-ui/react'

import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import GlucoseTable from './GlucoseTable'

import Layout from 'components/ManagerLayout'
import ExportData from './ExportData'

const Glucose = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <Layout>
            <Card>
                <CardHeader>
                    <Flex w="full" justifyContent="space-between" alignItems="center">
                        <Text>Monitoramento de Glicemia</Text>
                        <Button colorScheme='green' onClick={onOpen}>Exportar Dados</Button>
                        <ExportData isOpen={isOpen} onClose={onClose} />
                    </Flex>
                </CardHeader>
                <CardBody>
                    <GlucoseTable />
                </CardBody>
            </Card>
        </Layout>
    )
}

export default Glucose